import { Entity, resource } from 'aurelia-orm';
import { ValidationRules } from 'aurelia-validation';

@resource("AppointmentInfo")
export class AppointmentInfo extends Entity {
	id: String;
	subject: String;
	startTime: String;
	endTime: String;
	description: String;
	allDay: boolean;
	recurrence: boolean;
	categorize: string;

	constructor() {
		super();

		ValidationRules.customRule(
			'date',
			(value, obj) => {
				var d = new Date(value);
				var todaysDate = new Date();
				return d < todaysDate
			},
			`\${$displayName} not less than todays date.`
		);

		ValidationRules
			.ensure('startTime').required()
			.ensure('startTime').satisfiesRule('date')
			.ensure('endTime').required()
			.on(AppointmentInfo);
	}
}